import { useTranslation } from '@/translations/i18n'
import { ProPhotosGrid } from './pro-photos-grid'

interface ProPhotosTitleProps {
	imagesLength: number
	serviceTitle: string
	uploadButton: React.ReactNode
}

export const ProPhotosTitle = ({
	uploadButton,
	imagesLength,
	serviceTitle
}: ProPhotosTitleProps) => {
	const { t } = useTranslation()

	return (
		<ProPhotosGrid
			leftSlot={
				<div className='my-4 flex w-full items-center justify-between'>
					<div className='flex items-center gap-2'>
						<h3 className='font-medium text-base text-neutral-900'>
							{t('vetting:reordering.gallery')}
						</h3>
						{!!imagesLength && (
							<span className='text-sm'>
								{t('vetting:reordering.x_photos', {
									count: imagesLength
								})}
							</span>
						)}
					</div>

					{uploadButton}
				</div>
			}
			rightSlot={
				<div className='my-4 flex items-center'>
					<h3 className='font-medium text-base text-neutral-900'>
						{serviceTitle}
					</h3>
				</div>
			}
		/>
	)
}
ProPhotosTitle.displayName = 'ProPhotosTitle'
